"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LLConsumer = exports.LLProvider = exports.llContext = void 0;
const React = __importStar(require("react"));
const kendo_react_intl_1 = require("@progress/kendo-react-intl");
const ll_1 = require("./ll"); //spellcheck-off
exports.llContext = React.createContext({
    languageId: ll_1.defaultLanguageId
});
exports.llContext.displayName = "LocalizedLanguageContext";
exports.LLProvider = (props) => {
    const { languageId } = props.value;
    return (React.createElement(exports.llContext.Provider, { value: props.value },
        React.createElement(kendo_react_intl_1.LocalizationProvider, { language: languageId }, props.children)));
};
exports.LLConsumer = exports.llContext.Consumer;
//# sourceMappingURL=LLContext.js.map